// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SecondaryNav_wrapper__3tdZK","new":"SecondaryNav_new__2rT5n","nav":"SecondaryNav_nav__3D6XB","content":"SecondaryNav_content__3OERk"};